import { ReadyToSubmitRescueActions, SET_READY_TO_SUBMIT_RESCUE_SUCCESS } from "../action/readyToSubmitRescue-action";



export interface ReadyToSubmitRescueType {
  readyToSubmit: boolean;
}

const initialState : ReadyToSubmitRescueType = {
    readyToSubmit : false
} 


export default function  (
  state = initialState,
  action: ReadyToSubmitRescueActions
): ReadyToSubmitRescueType {
  switch (action.type) {
    case SET_READY_TO_SUBMIT_RESCUE_SUCCESS:
      return {
        ...state,
        readyToSubmit: action.payload
      };

    default:
      return state;
  }
};